import LoginAdminPage from "./LoginAdminPage";

export default LoginAdminPage;
